/* 班线调度 */
<template>
  <div id="dispatchLine">
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns">

      <template slot="customTable-top">
        <customAcrossRoll ref="customAcrossRoll" style="margin-bottom: 16px;">
          <div v-for="(schedulingTime, i) in schedulingTimeList" :key="i" class="date"
               :class="schedulingTimeActive == schedulingTime ? 'active' : ''"
               @click="schedulingTimeClick(schedulingTime)">
						<span class="date-text">
							{{ getWeek(schedulingTime) }}
							{{ schedulingTime | filterTime("MM-DD") }}
						</span>
          </div>
        </customAcrossRoll>
      </template>


      <template slot-scope="{item, row}">
        <template v-if="item.prop == 'registerTime'">{{ row.registerTime | filterTime }}</template>
        <template v-else-if="item.prop == 'status'">
          <span v-if="row.status == 1 && row.isEnabled == 1" style="color:#009900">正售</span>
          <span v-else style="color: #999">停售</span>
        </template>

        <template v-else-if="item.prop == 'occupySeat'">

            <span>
              {{ row.occupySeat || '-' }} <span
                v-if="row.occupySeatTimestamp && row.occupySeat!=0">({{
                row.occupySeatTimestamp | filterTime2('HH:mm')
              }}恢复座位)</span>
            </span>

        </template>
        <template v-else-if="item.prop == 'registerType'">
					<span :style="{ color: row.registerType == 1 ? '#009900' : '#999' }">
						{{ row.registerType == 1 ? '已报班' : '未报班' }}
					</span>
          <i v-if="row.registerType == 1" class="el-icon-printer"
             style="margin-left: 10px;color:#409EFF;font-size:18px;cursor: pointer;" @click="print(row)"></i>
        </template>
        <template v-else-if="item.prop == 'startStationName'">
          {{ row.startStationName }} - {{ row.endStationName }}
        </template>
        <template v-else-if="item.prop == 'startTime'">{{ row.startTime }}</template>
        <template v-else-if="item.prop == 'vehicleSeat'">
          <span>
            {{ row.vehicleSeat }}
            <span style="color: #999" v-if="row.followPersonnelSeat">(随车:{{ row.followPersonnelSeat }})</span>
          </span>
        </template>
        <template v-else-if="item.prop == 'fee'">￥{{ row.fee }}</template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>

      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="170px" v-slot="{ row }">
          <!--          <el-dropdown-item v-if="row.registerType == 0" command=""></el-dropdown-item>-->
          <el-button type="text" :disabled="(row.registerType !== 0 || !row.licenseNo) || row.editStatus== -1  "
                     @click="applyClick(row)">报班
          </el-button>
          <el-button :disabled="row.editStatus== -1" type="text" @click="editTimeClick(row)">修改时间</el-button>
          <el-tooltip content="报班" placement="top"
                      v-if="row.status == 1 && row.isEnabled == 1 && row.registerType == 2">
            <i class="iconfont icon-pass" @click="applyClick(row.id)"></i>
          </el-tooltip>
          <el-dropdown @command="handleCommand($event, row)">
						<span class="el-dropdown-link">
							更多<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item :disabled="row.editStatus== -1" command="editVehicle">更换车辆</el-dropdown-item>
              <el-dropdown-item :disabled="row.editStatus== -1" command="statusChange">
                {{ row.status == 1 && row.isEnabled == 1 ? '停止' : '开启' }}售票
              </el-dropdown-item>
              <el-dropdown-item  command="addShift">增加班次</el-dropdown-item>
              <el-dropdown-item  v-if="btnPreFn('occupy_seat', false)" command="occupySeat">
                {{ row.occupySeat > 0 ? '恢复占座' : '占座' }}
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </template>
    </custom-table>

    <!-- 修改时间 -->
    <el-dialog title="修改时间" :visible.sync="visibleEditTime" width="470px" :close-on-click-modal="false"
               class="editTime">
      <div>
        <div class="flex">
          <span>班次时间</span>
          <!--          <el-time-picker  format="HH:mm" value-format="HH:mm"/>-->
          <el-input maxLength="4" @input="editTime.startTime=editTime.startTime.replace(/[^\d]/g,0)"
                    v-model="editTime.startTime"
                    placeholder="请输入内容"></el-input>

          <!--          <span style="margin-left: 50px;">发车时间</span>-->
          <!--          <el-time-picker v-model="editTime.endTime" format="HH:mm" value-format="HH:mm"/>-->
        </div>

        <div style="margin-top: 20px" v-if="editTime.licenseNo && editTime.inspectStartTime">
          {{ editTime.licenseNo }}安检有效期：{{
            editTime.inspectStartTime | filterTime2('YYYY.MM.DD HH:mm')
          }}-{{ editTime.inspectEndTime | filterTime2('MM.DD HH:mm') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="visibleEditTime = false">取消</el-button>
				<el-button type="primary" @click="saveTime">确定</el-button>
			</span>
    </el-dialog>

    <!-- 更换车辆 -->
    <schedulingVehicle :visible.sync="visibleEditVehicle" :line="lineInfo" :scheduling="editShiftForm"
                       :vehicleId="editShiftVehicleId" @confirm="saveVehicle"/>

    <!-- 报班单打印内容 -->
    <div id="print" v-if="printContent.organizationName">
      <div style="padding: 2rem 1rem;font-size:10px">
        <div style="margin-bottom: 5px;text-align: center;">报班单</div>
        <div style="margin-bottom: 20px;text-align: center;">（{{ printContent.organizationName }}）</div>

        <div style="margin-bottom: 20px;line-height: 2rem;">
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <span>日期：{{ printContent.registerTime }}</span>
            <span>班次：{{ printContent.startTime }}-{{ printContent.endTime }}</span>
          </div>
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <span>车辆号牌：{{ printContent.licenseNo }}</span>
            <span>售票数：{{ printContent.soldTickets }}</span>
          </div>
          <div>班次号：{{ printContent.schedulingId }}</div>
          <div>线路：{{ printContent.startStationName }}-{{ printContent.endStationName }}</div>
          <div>报班员：{{ printContent.registerUser }}</div>
        </div>
      </div>
    </div>

    <el-dialog
        title="占座"
        :before-close="handClose"
        :visible.sync="occupySeatShow"
        destroy-on-close
        width="400px">
      <addOccupy :loadData="loadData" @handClose="handClose" v-if="occupySeatShow"></addOccupy>
    </el-dialog>


    <el-dialog
        title="恢复占座"
        :before-close="handClose"
        :visible.sync="occupyRestoreShow"
        destroy-on-close
        width="400px">
      <restoreOccupy :loadData="loadData" @handClose="handClose" v-if="occupyRestoreShow"></restoreOccupy>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "dispatchLine",
  components: {
    customAcrossRoll: () => import("@/components/custom-across-roll.vue"),
    schedulingVehicle: () => import("@/page/scheduling/line/schedulingVehicle.vue"),
    addOccupy: () => import("./components/addOccupy"),
    restoreOccupy: () => import("./components/restoreOccupy"),
  },
  data() {
    return {
      loadData: {},
      schedulingTimeActive: null,
      schedulingTimeList: [],
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/line/station/dispatch',
        params: {
          schedulingTime: this.$route.query.schedulingTime ? this.$route.query.schedulingTime : new Date().setHours(0, 0, 0, 0) / 1000,
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: "select", field: "lineId", name: "搜索线路", value: null,
            filterable: true,
            props: {label: 'stationName', value: 'id',},
            option: []
          },
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {type: "input", field: "registerUser", name: "报班员", value: ""},
          {type: "input", field: "schedulingId", name: "班次号", value: ""},
          {
            type: "select", field: "registerType", name: "报班状态", value: null,
            option: [
              {value: "1", label: "已报班"},
              {value: "0", label: "未报班"}
            ],
          },
          {
            type: "select", field: "status", name: "售票状态", value: null,
            option: [
              {value: 1, label: "正售"},
              {value: 2, label: "停售"}
            ],
          },
        ]
      },
      // 表头
      columns: [
        {prop: 'status', label: '售票状态', width: 80},
        {prop: "registerType", label: "报班状态", width: 100},
        {prop: 'startStationName', label: '线路名称'},
        {prop: "startTime", label: "班次", width: 70},
        {prop: 'licenseNo', label: '车辆号牌', width: 90},
        {prop: "vehicleNo", label: "车辆编号", width: 80},
        {prop: "vehicleModel", label: "车型", width: 100},
        {prop: "vehicleSeat", label: "座位数", width: 100},
        {prop: "soldTickets", label: "已售票", width: 60},
        {prop: "remainingTickets", label: "余票", width: 60},
        {prop: "occupySeat", label: "占座", width: 135},
        {prop: "registerTime", label: "报班时间", width: 130},
        {prop: "registerUser", label: "报班员", width: 80},
        {prop: "schedulingId", label: "班次号", width: 80},
        {prop: "fee", label: "票价", width: 70}

      ],
      visibleEditTime: false,
      editTime: {startTime: null, endTime: null},

      visibleEditVehicle: false,
      lineInfo: {},
      editShiftForm: {},
      editShiftVehicleId: null,

      printContent: {},
      occupySeatShow: false,
      occupyRestoreShow: false
    }
  },
  created() {
    this.loadSchedulingTimeList();
  },
  methods: {
    handClose() {
      this.occupySeatShow = false
      this.occupyRestoreShow = false
      this.$refs.customTable.listFn()
    },
    /* 初始化未来30天时间戳 */
    loadSchedulingTimeList() {
      let minTime = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
      let schedulingTimeList = [];
      for (let i = 0; i < 30; i++) {
        schedulingTimeList.push(minTime + 86400 * i);
      }
      this.schedulingTimeActive = this.$route.query.schedulingTime ? this.$route.query.schedulingTime : minTime;
      this.schedulingTimeList = schedulingTimeList;
    },
    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },
    /* 点击时间戳 */
    schedulingTimeClick(schedulingTime) {
      this.schedulingTimeActive = schedulingTime;
      this.customOptions.params.schedulingTime = schedulingTime
      this.$refs.customTable.listFn()
    },

    /* 点击下拉按钮 */
    handleCommand(e, row) {
      this[e](row);
    },

    async occupySeat(row) {

      if (row.occupySeat > 0) {
        this.loadData = row
        this.occupyRestoreShow = true

      } else {
        this.loadData = row
        this.occupySeatShow = true
      }


    },

    /* 报班 */
    async applyClick(row) {
      const url1 = '/api/v1/manage/inspect/' + row.vehicleId
      let data1 = await this.$axios.get(url1);
      const statusRow = {
        '-1': '该车辆未安检',
        '0': '该车辆安检不合格',
        '2': '该车辆安检超期',
      }
      const h = this.$createElement;
      this.$msgbox({
        title: '报班',
        message: data1.data == 1 ? h('p', null, [
          h('div', null, `车辆【${row.licenseNo}】确认报班吗？`)]) : h('p', null, [
          h('div', null, `车辆【${row.licenseNo}】确认报班吗？`),
          h('div', {style: 'color: red;paddingTop:10px'}, `注意:${statusRow[data1.data]}`)
        ]),
      }).then(async () => {
        let url = '/api/v1/manage/line/register/vehicle';
        let params = {schedulingId: row.schedulingId};
        let data = await this.$axios.put(url, params);
        if (data && data.code == 1) {
          this.$message.success('报班成功');
          this.$refs.customTable.listFn();
        }
      })
    },

    /* 打印报班单 */
    print(row) {
      this.printContent = {
        organizationName: row.organizationName,
        registerTime: new Date(this.schedulingTimeActive * 1000).toLocaleDateString().replace(new RegExp('/', 'g'), "."),
        startTime: row.startTime,
        endTime: row.endTime,
        licenseNo: row.licenseNo,
        soldTickets: row.soldTickets,
        schedulingId: row.schedulingId,
        startStationName: row.startStationName,
        endStationName: row.endStationName,
        registerUser: row.registerUser
      }

      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
      })
    },

    /* 开启/停止 售票 */
    async statusChange(row) {
      let params = {
        schedulingId: row.schedulingId,
        isEnabled: row.isEnabled == 1 ? 2 : 1
      };
      let url = "/api/v1/manage/line/scheduling/isEnabled";
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message({type: "success", message: `班次已${params.isEnabled == 1 ? '开启' : '停止'}售票`});
        this.$refs.customTable.listFn()
      }
    },

    /* 修改时间 */
    async editTimeClick(row) {
      console.log(row, 11);
      // if (row.soldTickets > 1) {
      // 	this.$message.warning('班次已有乘客购票，无法修改');
      // 	return
      // }
      if (row.vehicleId) {
        let url = "/api/v1/manage/inspect/time/" + row.vehicleId;
        let data = await this.$axios.get(url);
        if (data && data.code == 1) {
          this.editTime = {
            ...row,
            ...data.data,
            schedulingId: row.schedulingId,
            startTime: row.startTime.split(':').join(''),
            endTime: row.startTime.split(':').join(''),
          }
        }
      } else {
        this.editTime = {
          schedulingId: row.schedulingId,
          startTime: row.startTime && row.startTime.split(':').join(''),
          endTime: row.startTime && row.startTime.split(':').join(''),
        }
      }


      this.visibleEditTime = true;

    },
    /* 确定修改时间 */
    async saveTime() {
      if (this.editTime.startTime.length !== 4) {
        this.$message.error('请输入4位数字，例如0520')
        return
      }
      const hour = this.editTime.startTime.substring(2, 0)
      const mint = this.editTime.startTime.substring(2, 4)
      console.log(hour, mint, 111);
      if (hour > 24) {
        this.$message.error('请输入正确的时间格式，例如0520')
        return
      }

      if (mint > 59) {
        this.$message.error('请输入正确的时间格式，例如0520')
        return
      }
      // if (!this.editTime.startTime || !this.editTime.endTime || this.editTime.startTime > this.editTime.endTime) {
      //   this.$message.warning('发车时间必须大于等于检票时间');
      //   return;
      // }
      let url = '/api/v1/manage/line/register/time';
      let data = await this.$axios.put(url, {
        ...this.editTime,
        startTime: `${hour}:${mint}`,
        endTime: `${hour}:${mint}`,
      });
      if (data && data.code == 1) {
        this.$message.success('修改成功');
        this.visibleEditTime = false;
        this.$refs.customTable.listFn()
      }
    },

    /* 更换车辆 */
    async editVehicle(row) {
      // if (row.soldTickets > 1) {
      // 	this.$message.warning('班次已有乘客购票，无法修改');
      // 	return
      // }

      let url = "/api/v1/manage/line/scheduling/" + row.lineId;
      let res = await this.$axios.get(url, {channel: 1});
      if (res?.code == 1 && res.data) {
        this.lineInfo = res.data.line;
        this.editShiftForm = row;
        this.editShiftVehicleId = row.vehicleId;
        this.visibleEditVehicle = true;
      }
    },

    /* 确定更换车辆 */
    async saveVehicle(result) {
      let url = "/api/v1/manage/line/station/change/vehicle";
      let params = {
        schedulingId: this.editShiftForm.schedulingId,
        ...result
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success('车辆已更换');
        this.$refs.customTable.listFn();
      }
    },

    /* 增加班次 */
    async addShift(row) {
      if (this.menuPreFn(66)) {
        this.$router.push({
          path: '/schedulingTimeFormEdit',
          query: {id: row.lineId, schedulingTime: this.schedulingTimeActive}
        })
      } else {
        this.$message.warning('当前机构或账号无权限，请联系管理员');
      }
    }
  }
}
</script>

<style lang="less">
#dispatchLine {
  .flex > * {
    flex-shrink: 0;
    max-width: 100px;
    margin-right: 10px;
  }

  .el-icon-arrow-down {
    font-size: 14px;
  }
}

iframe,
#print {
  width: 0;
  height: 0;
  position: absolute;
  left: -500px;
  top: -500px;
}
</style>
